// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AuditCount from '@deere/cps-it.warranty-model-factory/lib/audit-count';
import {FormattedMessage} from 'react-intl';
import {buildNumber} from '../../../shared/services/build-number';

const getDisplayParams = auditCount => {

    let className,
        id,
        value;

    className = '';
    id = 'AUDITS_DUE_WITH_COUNT';
    value = 0;

    if (auditCount.pastDueAudits > 0) {

        className = 'dot-icon-red';
        id = 'AUDITS_PAST_DUE_WITH_COUNT';
        value = auditCount.pastDueAudits;

    } else if (auditCount.pastDueAudits < 1 && auditCount.auditsDueIn30Days > 0) {

        className = 'dot-icon-yellow';
        id = 'AUDITS_DUE_WITHIN_30_DAYS';
        value = auditCount.auditsDueIn30Days;

    }

    return ({
        className,
        id,
        value
    });

};

const AuditCountPanel = props => {

    const displayParams = getDisplayParams(props.auditCount);

    return (
        <div className='audit-count-panel'>
            <header>
                <FormattedMessage id='AUDITS'/>
            </header>
            <div className='counts'>
                <a href={'#/tcsm/audits'}>
                    <FormattedMessage
                        id={displayParams.id}
                        values={{
                            count: displayParams.value,
                            countToDisplay: buildNumber(displayParams.value)
                        }}
                    />
                </a>
                <span className={displayParams.className}/>
            </div>
        </div>
    );

};

AuditCountPanel.displayName = 'AuditCountPanel';
AuditCountPanel.propTypes = {
    auditCount: PropTypes.instanceOf(AuditCount).isRequired
};

export default AuditCountPanel;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/audit-count-panel.js